"use client";

import { useTranslations } from "next-intl";

const GOOGLE_REVIEWS_URL = "https://www.google.com/maps/place/saiyan+gym+FITT/@42.6595946,18.0732326,1384m/data=!3m1!1e3!4m8!3m7!1s0x134c756c62b6ec3d:0xc72b267de58c4746!8m2!3d42.6595907!4d18.0758075!9m1!1b1!16s%2Fg%2F11t71_5c0l?entry=ttu&g_ep=EgoyMDI2MDQxNC4wIKXMDSoASAFQAw%3D%3D";

const REVIEWS = [
  {
    id: 1,
    text: "\"Amazing gym space! Spacious, clean, new and varied equipment. They even have a few lifting platforms, and a room suited for functional training (however for an extra cost). As a tourist in the area, I visited for 18 euro. They also have great locker rooms with toilets, showers and hairdryers. The staff are friendly ...\"",
    name: "Rachel Thomas",
    url: "https://maps.app.goo.gl/qEgfd4EquK97AXEBA",
  },
  {
    id: 2,
    text: "\"Did not expect to find such a nice gym in a small town. But I was pleasantly surprised. Lots of hammer strength plate loaded pieces and nautilus machines. 10/10. I love the theme of it also, feels super cool even though I’m not into anime. Highly recommended.\"",
    name: "Yegor Adamovich",
    url: "https://maps.app.goo.gl/SL2rPdx4pfsFq6hq5",
  },
  {
    id: 3,
    text: "\"I trained at this gym whilst on my travels in Croatia. The owner was super polite, responsive to messages via instagram. The cost for casual entry was very affordable and I was allowed access to train early between the hours of 5-6am. The facility is very clean and fantastic equipment. I highly recommend this gym!\"",
    name: "Sarah Duggan",
    url: "https://maps.app.goo.gl/XccZbBtaKkWHwCXh6",
  },
];

// Google coloured G SVG
function GoogleIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="h-5 w-5 shrink-0" aria-hidden="true">
      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05" />
      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
    </svg>
  );
}

// Arrow-up-right icon inline
function ArrowUpRightIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-3.5 w-3.5" aria-hidden="true">
      <path d="M7 17L17 7" />
      <path d="M7 7h10v10" />
    </svg>
  );
}

export default function ReviewsSection() {
  const t = useTranslations("Reviews");

  return (
    <section className="mx-auto max-w-6xl px-6 py-16 sm:px-8 lg:px-10">
      {/* Header row */}
      <div className="mb-8 flex items-center justify-between gap-4">
        <h2 className="text-4xl font-black tracking-tight text-[#18181b]">
          {t("heading")}
        </h2>
        <a
          href={GOOGLE_REVIEWS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex shrink-0 items-center gap-2 rounded-full border border-[#E4E4E7] bg-white px-5 py-2.5 text-sm font-medium text-[#18181b] transition-colors hover:bg-[#F9FAFB]"
        >
          {t("seeAllCta")}
          <GoogleIcon />
        </a>
      </div>

      {/* Cards row */}
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {REVIEWS.map((review) => (
          <div
            key={review.id}
            className="flex flex-col justify-between gap-6 rounded-2xl border border-[#E4E4E7] bg-[#F9FAFB] p-6"
          >
            {/* Review text + "Vidi još" */}
            <div className="flex flex-col gap-4">
              <p className="text-sm italic leading-relaxed text-[#3f3f46] line-clamp-6">
                {review.text}
              </p>
              <a
                href={review.url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex w-fit items-center gap-1.5 rounded-full border border-[#E4E4E7] bg-white px-4 py-1.5 text-sm font-medium text-[#18181b] transition-colors hover:bg-[#f4f4f5]"
              >
                {t("seeMoreCta")}
                <ArrowUpRightIcon />
              </a>
            </div>

            {/* Reviewer name */}
            <p className="text-sm font-semibold text-[#18181b]">{review.name}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
